import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Waypoint from 'react-waypoint'
import { range } from 'lodash'
import WordCloudPreview from '../components/WorldCloudPreview'

const SHOW_STEP = 6
const SHOW_TRESHOLD = 4

class IndexPage extends PureComponent {
  state = {
    toShow: SHOW_STEP,
  }

  componentDidMount() {
    const clouds = this.props.data.allCloudsJson.edges.map(({ node }) => node)
    this.context.setClouds(clouds)
  }

  handleCloudClick = (cloud) => {
    this.props.history.push({
      pathname: `/cloud/${cloud.name}`,
      state: { modal: true },
    })
  }

  enterViewport = (i) => {
    const size = this.props.data.allCloudsJson.edges.length
    const { toShow } = this.state
    if (i >= toShow - SHOW_TRESHOLD) {
      // console.log('Show more', i)
      const nextToShow = Math.min(toShow + SHOW_STEP, size)
      if (toShow !== nextToShow) {
        this.setState({ toShow: nextToShow })
      }
    }
  }

  render() {
    const { data } = this.props
    const { toShow } = this.state
    console.log("X")
    // console.log(data)
    return (
    <div className='row'>
      {range(Math.min(toShow, data.allCloudsJson.edges.length)).map(index => {
        const e = data.allCloudsJson.edges[index]
        return (
          <div key={e.node.name} className='col-sm-12 col-md-6'>
            <WordCloudPreview
              onClick={this.handleCloudClick}
              wordCloud={e.node}
            />
            <Waypoint
              onEnter={() => this.enterViewport(index, e.node)}
            />
          </div>
        )
      })}
    </div>
  )
  }
}

IndexPage.contextTypes = {
  setClouds: PropTypes.func,
}

export default IndexPage

export const query = graphql`
  query GetCloudsQuery {
    allCloudsJson(limit: 1000, sort: { order: DESC, fields: [date] }) {
    	edges {
        node {
       		name,
          date,
        	image,
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js